import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    border: '1px solid #00000010',
    borderRadius: 4,
    minHeight: 300,
    paddingLeft: 30,
    paddingRight: 30,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 5,
      paddingRight: 5,
    },
  },
  chatContainer: {
    paddingTop: 30,
    paddingBottom: 10,
    overflow: 'auto',
    width: '100%',
    height: 'calc(300px)',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  form: {
    width: '100%',
  },
  input: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  inputText: {
    paddingBottom: 30,
    [theme.breakpoints.down('md')]: {
      paddingBottom: 5,
    },
  },
  avatar: {
    backgroundColor: '#00000020',
    height: 30,
    width: 30,
    borderRadius: 30,
  },
  chatItemContainer: {
    margin: '5px 0px',
    textAlign: 'left',
  },
  ChatBubbleContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    marginBottom: 2,
  },
  row: {
    flexDirection: 'row',
  },
  rowReverse: {
    flexDirection: 'row-reverse',
  },
  ChatBubble: {
    padding: 5,
    margin: '0 5px',
    color: 'white',
    borderRadius: 40,
  },
  mine: {
    backgroundColor: '#00d070',
    borderRadius: '10px',
    borderTopLeftRadius: 2,
  },
  other: {
    backgroundColor: '#3b93ff',
    borderRadius: '10px',
    borderTopRightRadius: 2,
  },
  dateHolder: {
    margin: '0px 20px',
  },
  fileInputButton: {
    position: 'relative',
  },
  fileInput: {
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    borderRadius: '50%',
  },
  alert: {
    position: 'absolute',
    width: '100%',
    zIndex: 2000,
    top: -60,
  },
  alertholder: {
    position: 'relative',
  },
  fileContainer: {
    position: 'relative',
    width: 200,
    borderRadius: 5,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#e1e9ea',
    backgroundImage: 'url(/images/image.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    minHeight: 150,
    backgroundSize: '4.5rem',
  },
  fileImage: {
    backgroundColor: '#e1e9ea',
    width: '100%',
    userDrag: 'none',
    userSelect: 'none',
  },
  downloadButton: {
    position: 'absolute',
    right: 10,
    top: 10,
    padding: 4,
    bprderRadius: 5,
    zIndex: 1000,
    backgroundColor: '#00000020',
  },
  otherFiles: {
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
  },
  fileDownloadButton: {
    borderRadius: 5,
    '& > span > label': {
      fontSize: 16,
      paddingRight: 10,
    },
  },
}))
